<ion-badge mode="ios" [ngClass]="status ? (status | lowercase) : 'gray'">
  <ion-icon [name]="statusIcon(status)" *ngIf="statusIcon(status) !== 'ribbon-sharp'" ></ion-icon>
  <ion-icon src="assets/ribbon.svg" *ngIf="statusIcon(status) === 'ribbon-sharp'"></ion-icon>
    <ion-text>
      {{ status | StatusSimplifiedReurb}}
    </ion-text>
</ion-badge>
